export default __webpack_public_path__ + "static/media/resume.ff9d67ca.pdf";